import { Route, Routes } from "react-router-dom";
import routes, { RouteConfig } from "@/routes";
import NotFound from "@/pages/NotFound/index";
import AuthRoute from "@/auth/app";
import KeepAlive, { AliveScope } from "react-activation";
import "react-animated-router/animate.css";

const renderRoutes = (routes: RouteConfig[]) => {
	return routes.map((route, index) => {
		const { path, element, children, auth, keepAlive } = route;
		return (
			<Route
				key={index}
				path={path}
				element={
					<KeepAlive key={path} when={keepAlive}>
						<AuthRoute auth={auth} key={path}>
							{element}
						</AuthRoute>
					</KeepAlive>
				}
			>
				{children && children.length > 0 && renderRoutes(children)}
			</Route>
		);
	});
};

const AppRoutes: React.FC = () => (
	<AliveScope>
		<Routes>
			{renderRoutes(routes)}
			<Route path="*" element={<NotFound />} />
		</Routes>
	</AliveScope>
);

export default AppRoutes;
